import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaCardComponent} from './la-card.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaCardComponent],
  exports: [LaCardComponent]
})
export class LaCardModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaCardModule,
      providers: []
    }
  }
}
